import React, { useEffect } from 'react';
//import { ultimasNoticias } from '../../json/ultimasNoticias';
import './organismos.css';

const Plataformas = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Plataformas digitales</h3>
                <hr className='hr-gob'/>
            </div>
            {
              window._my_ultimasNoticias.filter(p => p.app).length>0 ?
                window._my_ultimasNoticias.filter(p => p.app).map((item, i) =>
                    <div>
                        <div className="titulo_app">
                            {item.titulo}
                        </div>
                        <a href={item.url} target="_new" className="img_app">
                            <img src={item.imagen} title={item.titulo} alt={item.titulo}/>
                        </a>
                    </div>
                )
              :
                null  
            }
            <div id="mi_espacio"/>
        </div>
    </div>
  )
}

export default Plataformas